<template>
  <v-dialog
    max-width="800"
    persistent
    transition="dialog-bottom-transition"
    v-model="showForm"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Apply custom application config</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form">
        <v-card flat v-bind:loading="uploading">
          <v-card-title>
            Upload File
          </v-card-title>
          <v-card-text>
            <vue-dropzone
              id="fileDropZone"
              ref="fileDropZone"
              :awss3="awss3"
              :options="dropzoneOptions"
              v-on:vdropzone-files-added="replaceFile"
              v-on:vdropzone-s3-upload-error="s3UploadError"
              v-on:vdropzone-s3-upload-success="s3UploadSuccess"
            ></vue-dropzone>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            Run Options
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                  <v-radio label="Run now" value="now"></v-radio>
                  <v-radio label="Schedule" value="schedule"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="9">
                <CloudWatchCronExpressionBuilder
                  v-model="scheduleExpression"
                  v-if="schedule"
                  show-next-events="5"
                >
                </CloudWatchCronExpressionBuilder>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="triggerUpload()">Run</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from '@/components/forms/DropzoneS3'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'

import {
  APPLY_CUSTOM_APPLICATION_CONFIG,
  SCHEDULE_APPLY_CUSTOM_APPLICATION_CONFIG
} from '@/domain/showcases/constants/query'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'
export default {
  name: 'ShowcaseOperationsExecution',
  components: {
    vueDropzone: vue2Dropzone,
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showForm: true,
    uploading: false,
    fileS3Key: null,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null,
    dropzoneOptions: {
      url: 'https://httpbin.org/post',
      autoProcessQueue: false,
      thumbnailWidth: 150,
      maxFilesize: 10,
      destroyDropzone: true,
      maxFiles: 1,
      addRemoveLinks: true
    }
  }),
  props: ['showcase', 'display'],
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    },
    awss3: function() {
      return {
        prefix: this.showcase.showcaseId
      }
    }
  },
  methods: {
    triggerUpload: async function() {
      this.uploading = true
      this.message = 'Upload in progress'
      this.$refs.fileDropZone.processQueue()
      this.uploading = false
    },
    s3UploadError(errorMessage) {
      this.message = errorMessage
    },
    s3UploadSuccess(s3ObjectLocation) {
      this.message = 'Upload succeeded'
      this.fileS3Key = s3ObjectLocation
      this.runOperation()
    },
    runOperation() {
      let operationHandler =
        this.scheduleOrNow === 'now'
          ? this.operationHandler
          : this.scheduleOperationHandler
      operationHandler()
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    async operationHandler() {
      this.message = 'Starting Operation'
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: APPLY_CUSTOM_APPLICATION_CONFIG,
        variables: {
          showcaseId: this.showcase.showcaseId,
          applicationConfigS3Key: this.fileS3Key
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler() {
      this.message = 'Scheduling Operation'
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SCHEDULE_APPLY_CUSTOM_APPLICATION_CONFIG,
        variables: {
          showcaseId: this.showcase.showcaseId,
          applicationConfigS3Key: this.fileS3Key,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    isScheduleOnceType(expression) {
      return (
        this.scheduleExpression.match(/^(\d+) (\d+) (\d+) (\d+) \? (\d+)$/) !==
        null
      )
    },
    closeDialog() {
      this.$emit('close')
    },
    replaceFile(input) {
      if (input.length !== undefined && input.length > 1) {
        this.message = 'Only one file allowed!'
        input.forEach(file => this.$refs.fileDropZone.removeFile(file))
      } else if (this.$refs.fileDropZone.getQueuedFiles().length > 0) {
        let queuedFile = this.$refs.fileDropZone.getQueuedFiles()[0]
        let newFile = input[0]
        if (newFile !== queuedFile) {
          this.$refs.fileDropZone.removeFile(newFile)
          this.$refs.fileDropZone.removeFile(queuedFile)
          this.$refs.fileDropZone.addFile(newFile)
        }
      }
    }
  }
}
</script>

<style scoped></style>
